<template>
  <a-card>
    <!-- 条件搜索 -->
     <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="訂單号">
              <a-input v-model="queryParams.tradeNo" placeholder="请输入訂單号" allow-clear @pressEnter="handleQuery" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="支付訂單号">
              <a-input v-model="queryParams.orderId" placeholder="请输入支付訂單号" allow-clear @pressEnter="handleQuery" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          :pagination="false"
          @refresh="getList" />
      </div>
    <a-table :loading="loading" :data-source="tableData" :columns="columns" :size="tableSize" rowKey="id"
      :pagination="false">
      <div slot="payAmount" slot-scope="text"> {{ text | moneytransfer }} </div>
      <div slot="refundAmount" slot-scope="text"> {{ text | moneytransfer }} </div>
      <div slot="status" slot-scope="text"> {{ text | statusBypay }} </div>
      <div slot="notifyStatus" slot-scope="text"> {{ text | statusByNotify }} </div>
      <div slot="action" slot-scope="text, record">
        <a href="javascript:void(0)" @click="handleClick(record)" class="margin-right-sm">编辑</a>
        <a-popconfirm title="确定要刪除该运费模板吗？" ok-text="确定" cancel-text="取消" @confirm="delFreight(record)">
          <a href="javascript:void(0)" style="color:red;">刪除</a>
        </a-popconfirm>
      </div>
    </a-table>
    <!-- 分页 -->
    <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParams.pageNum"
      :total="total" :page-size="queryParams.pageSize" :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange" @change="changeSize" />
  </a-card>
</template>
<script>
import { tableMixin } from '@/store/table-mixin'
import * as paychannel from '@/api/pay/pay.js'
export default {
  mixins: [tableMixin],
  data() {
    return {
      loading: false,
      columns: [{
        title: '訂單号',
        dataIndex: 'tradeNo',
        width: 60,
        type: 'text'
      },{
        title: '支付訂單号',
        dataIndex: 'orderId',
        width: 80,
        type: 'text'
      },{
        title: '支付金額(元)',
        dataIndex: 'payAmount',
        width: 60,
        type: 'text',
        scopedSlots: { customRender: 'payAmount' }
      },{
        title: '退款金額(元)',
        dataIndex: 'refundAmount',
        width: 60,
        type: 'text',
        scopedSlots: { customRender: 'refundAmount' }
      },{
        title: '退款狀態',
        dataIndex: 'status',
        width: 50,
        type: 'text',
        scopedSlots: { customRender: 'status' }
      },{
        title: '回调狀態',
        dataIndex: 'notifyStatus',
        width: 50,
        type: 'text',
        scopedSlots: { customRender: 'notifyStatus' }
      },{
        title: '回调時間',
        dataIndex: 'notifyTime',
        width: 50
      },{
        title: '退款成功時間',
        dataIndex: 'successTime',
        width: 60,
        type: 'time'
      },{
        title: '創建時間',
        dataIndex: 'createTime',
        width: 60,
        type: 'time'
      }],
      tableData: [],
      // 总条数
      total: 0,
      // 查詢参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        tradeNo: null,
        orderId: null,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      paychannel.refundOList(this.queryParams).then(res => {console.log('res8888888', res)
        if (res.success) {
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
        }
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams =  {
          pageNum: 1,
          pageSize: 10,
          tradeNo: null,
          orderId: null,
      };
      this.handleQuery();
    },
    onShowSizeChange (current, pageSize) {
      this.queryParams.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParams.pageNum = current
      this.queryParams.pageSize = pageSize
      this.getList()
    },
  },
  filters: {
    // 金額由分转换成元
    moneytransfer(val) {
      let newval = (val) / 100
      return newval
    },
    // 退款狀態，0-正在退款 1-退款成功 2-退款失败 3-退款关闭
    statusBypay(type) {
      let str = ''
      switch (type) {
        case 0: str = '退款中';
          break;
        case 1: str = '退款成功';
          break;
        case 2: str = '退款失败';
          break;
        case 3: str = '退款关闭';
          break;
        default: str = ''
      }
      return str
    },
    // 通知商户退款结果的回调狀態,1-等待通知,2-通知成功，3-通知失败
    statusByNotify(type) {
      let str = ''
      switch (type) {
        case 1: str = '等待通知';
          break;
        case 2: str = '通知成功';
          break;
        case 3: str = '通知失败';
          break;
        default: str = ''
      }
      return str
    },
  },
}
</script>